var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"learnworlds-screen-caption bottom lw-brand-bg-fadeout60 js-lw-flexible-wrapper js-screen-caption",on:{"click":_vm.emitIt}},[_vm._t("caption")],2)}
var staticRenderFns = []

export { render, staticRenderFns }